import React from "react";
import { AdminManagedUser, AdminProductOption } from "../../../services/platformApi";
import ProductMultiSelectDropdown from "./ProductMultiSelectDropdown";
import SectionLoadingOverlay from "./SectionLoadingOverlay";

interface UserProductManagementSectionProps {
  lookupEmail: string;
  onLookupEmailChange: (value: string) => void;
  lookupLoading: boolean;
  lookupError: string;
  updateMessage: string;
  lookupUser: AdminManagedUser | null;
  editableProducts: string[];
  updateLoading: boolean;
  availableProducts: AdminProductOption[];
  isLookupProductDropdownOpen: boolean;
  onLookupProductDropdownOpenChange: (isOpen: boolean) => void;
  onToggleEditableProduct: (productKey: string) => void;
  onLookupUser: () => void;
  onUpdateProducts: () => void;
}

const UserProductManagementSection: React.FC<UserProductManagementSectionProps> = ({
  lookupEmail,
  onLookupEmailChange,
  lookupLoading,
  lookupError,
  updateMessage,
  lookupUser,
  editableProducts,
  updateLoading,
  availableProducts,
  isLookupProductDropdownOpen,
  onLookupProductDropdownOpenChange,
  onToggleEditableProduct,
  onLookupUser,
  onUpdateProducts,
}) => {
  const isSectionLoading = lookupLoading || updateLoading;

  return (
    <section className="admin-page__card">
      {isSectionLoading && (
        <SectionLoadingOverlay
          label={lookupLoading ? "Ieškomas naudotojas..." : "Saugomi naudotojo produktai..."}
        />
      )}

      <div className="admin-page__card-header">
        <h3>2. Rasti naudotoją ir keisti jo produktus</h3>
        <p>Įveskite vieną el. paštą, peržiūrėkite dabartinius produktus ir juos koreguokite.</p>
      </div>

      <div className="admin-page__inline-form">
        <label className="admin-page__field admin-page__field--inline">
          <span>Naudotojo el. paštas</span>
          <input
            value={lookupEmail}
            onChange={(event) => onLookupEmailChange(event.target.value)}
            placeholder="pvz. jonas@example.com"
          />
        </label>
        <button onClick={onLookupUser} disabled={isSectionLoading}>
          {lookupLoading ? "Ieškoma..." : "Rasti naudotoją"}
        </button>
      </div>

      {lookupError && <p className="admin-page__feedback admin-page__feedback--error">{lookupError}</p>}
      {updateMessage && (
        <p className="admin-page__feedback admin-page__feedback--success">{updateMessage}</p>
      )}

      {lookupUser && (
        <div className="admin-page__lookup-result">
          <div className="admin-page__summary-grid">
            <span>
              <strong>El. paštas:</strong> {lookupUser.normalizedEmail}
            </span>
            <span>
              <strong>Vardas:</strong> {lookupUser.name || "—"}
            </span>
            <span>
              <strong>Auth0:</strong> {lookupUser.auth0Exists ? "yra" : "nėra"}
            </span>
            <span>
              <strong>Firestore:</strong> {lookupUser.firestoreExists ? "yra" : "nėra"}
            </span>
          </div>

          <div className="admin-page__section-block">
            <div className="admin-page__section-copy">
              <h4>Produkto teisės</h4>
              <p>Pažymėkite visus produktus, kuriuos naudotojas turi turėti po išsaugojimo.</p>
            </div>
            <ProductMultiSelectDropdown
              availableProducts={availableProducts}
              selectedProducts={editableProducts}
              isOpen={isLookupProductDropdownOpen}
              onOpenChange={onLookupProductDropdownOpenChange}
              onToggleProduct={onToggleEditableProduct}
              productCertificationStatuses={lookupUser.productCertificationStatuses}
              showCertificationStatus
            />
          </div>

          <button
            className="admin-page__button admin-page__button--primary"
            onClick={onUpdateProducts}
            disabled={isSectionLoading}
          >
            {updateLoading ? "Saugoma..." : "Išsaugoti produktus"}
          </button>
        </div>
      )}
    </section>
  );
};

export default UserProductManagementSection;
